/**
 * 当前基础倍率均为 2 的整数次幂，其几何平均为有理数时也只能是 2 的整数次幂。
 * 仅格式化展示文字，伤害及克制判断仍使用未经舍入的原始倍率。
 */
export function formatScale(scale: number): string {
    const rational = scale === 0 || Number.isInteger(Math.log2(scale));
    return `${rational ? scale : scale.toFixed(2)}倍`;
}
